import { useMemo } from 'react';

import { MergeTag } from 'domains/content/types';
import { getFriendlyName } from 'utils';

const useFormatWhatsAppContent = (content: string, mergeTags: MergeTag[] = []) => {
    const formattedContent = useMemo(() => {
        if (!content) {
            return 'Start typing to see a live preview of your message here!';
        }

        const regex = /{{.*?}}/g;
        const matches = content.match(regex);

        if (matches && mergeTags?.length) {
            let formatted = content;

            for (const match of matches) {
                const mergeTag = mergeTags.find((tag) => tag.value === match);
                if (mergeTag) {
                    formatted = formatted.replaceAll(
                        match,
                        mergeTag.previewValue || `[${getFriendlyName(mergeTag.name)}]`
                    );
                }
            }

            return formatted;
        }

        return content;
    }, [content, mergeTags]);

    return formattedContent;
};

export default useFormatWhatsAppContent;
